<template>
	<div class="relative !px-4 flex flex-col gap-8 items-center !container mx-auto !max-w-seint">
		<div class="flex flex-col gap-3 w-full max-w-[400px] !px-4 !py-16">
			<h1 class="!m-0 !p-0 font-butler-light text-3xl/[38px] text-center font-light">Preparing your results...</h1>
			<img :src="LOADING.src" :alt="LOADING.alt" class="w-full object-contain animate-pulse" />
		</div>
	</div>
</template>
<script setup>
import { watch, onMounted } from 'vue'

const props = defineProps({
	loading: {
		type: Boolean,
		default: false,
	},
	step: {
		type: Number,
		default: null,
	},
	setStep: {
		type: Function,
		required: true,
	},
})

import { LOADING } from './config'

onMounted(() => {
	window.scrollTo(0, 0)
})

watch(
	() => props.loading,
	(isLoading) => {
		if (!isLoading && props.step === 6) {
			// was step 7 prior to input removal
			setTimeout(() => {
				props.setStep(7) // was 8
			}, 1000)
		}
	}
)
</script>
